<script lang="ts">
	import type {
		HTMLAnchorAttributes,
		HTMLButtonAttributes,
		MouseEventHandler
	} from 'svelte/elements';

	type Props = {
		click?: MouseEventHandler<HTMLButtonElement>;
		variant?: 'primary' | 'secondary' | 'secondary-icon' | 'ghost';
		size?: 'small' | 'medium' | 'large';
		to?: string | HTMLAnchorAttributes;
		children?: import('svelte').Snippet;
	} & HTMLButtonAttributes &
		HTMLAnchorAttributes;

	let {
		click = () => {
			/* noop */
		},
		variant = 'primary',
		size = 'medium',
		to = undefined,
		children,
		...rest
	}: Props = $props();
</script>

<div class={rest.class}>
	{#if to}
		<a
			{...rest}
			href="/"
			class={[variant, size].join(' ')}
			{...typeof to === 'string' ? { href: to } : to}
		>
			{@render children?.()}
		</a>
	{:else}
		<button {...rest} onclick={click} class={[variant, size].join(' ')}>
			{@render children?.()}
		</button>
	{/if}
</div>

<style lang="postcss">
	@reference '../../../app.css';

	a,
	button {
		@apply card-bold inline-flex w-full items-center justify-center rounded-full border-2 border-transparent px-4 whitespace-nowrap;

		&.primary {
			@apply text-white-pure bg-[#007dcb] hover:bg-[#1A66BB] disabled:opacity-30 disabled:hover:bg-[#007dcb];
		}

		&.secondary {
			@apply hover:text-white-pure border-1 border-[#007dcb] bg-transparent text-[#007dcb] hover:bg-[#007dcb];
		}

		&.secondary-icon {
			@apply border-1 border-[#2e2e2e] bg-transparent text-[#2e2e2e] hover:bg-[#1A66BB]/5;
		}

		&.ghost {
			@apply border-gray-light text-gray-dark border-1 bg-transparent hover:bg-[#1A66BB]/5;
		}

		&.small {
			@apply card-bold h-8;
		}

		&.medium {
			@apply card-bold h-12;
		}

		&.large {
			@apply body-bold h-14;
		}

		font-family: 'Raleway', sans-serif;
		font-optical-sizing: auto;
		font-weight: 800;
		font-style: normal;
	}
</style>
